import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'
import { getLangProperty } from '@appbase/util';

@Component({
    computed: mapGetters({
        user: accountTypes.USER
    })
})
export default class SearchBox extends Vue {
    @Prop({ type: Array }) criterias!: common.SearchBoxCriteria[];
    @Prop({ type: Object }) boardConfig!: board.BoardItem;

    user!: account.User;

    @Watch('criterias')
    criteriasChanged(newVal: common.SearchBoxCriteria[]) {
        if (newVal != null && newVal.length > 0) {
            this.mSearchField = newVal[0].value;
        }
    }

    @Watch('boardConfig')
    boardConfigChanged(newVal: board.BoardItem) {     
        if (newVal != null) {
            var prefaces = newVal.usePreface ? newVal.prefaces : null;
            this.mountPreface(prefaces);
        } else {
            this.mShowParentPreface = false;
            this.mShowChildPreface = false;
        }
    }
       
    mSearchField: string = "";

    mShowParentPreface: boolean = false;
    mShowChildPreface: boolean = false;
    parentPrefaceId: string = "";
    childPrefaceId: string = "";
    mParentPrefaces: board.BoardPreface[] = [];
    mChildPrefaces: board.BoardPreface[] = [];

    created() {
        this.criteriasChanged(this.criterias);
        this.boardConfigChanged(this.boardConfig);
    }

    mountPreface(prefaces: board.BoardPreface[] | null) {           
        if (prefaces == null) {
            this.mShowParentPreface = false;
            this.mShowChildPreface = false;
        } else {
            this.mShowChildPreface = true;
            this.mChildPrefaces = prefaces.filter(p => p.parentPrefaceId != null);

            if (this.mChildPrefaces.length > 0) {
                this.mShowParentPreface = true;
                this.mParentPrefaces = prefaces.filter(p => p.parentPrefaceId == null);               
            } else {
                this.mShowParentPreface = false;
                this.mChildPrefaces = prefaces;
            }
        }
    }

    onParentPrefaceChanged() {
        if (this.boardConfig != null) {
            var prefaces = this.boardConfig.prefaces;            
            if (this.parentPrefaceId === "") {                 
                this.mChildPrefaces = prefaces.filter(p => p.parentPrefaceId != null);
            } else {
                this.mChildPrefaces = prefaces.filter(p => p.parentPrefaceId === this.parentPrefaceId);                   
            }
            this.childPrefaceId = "";
            var returnId = this.parentPrefaceId === "" ? null : this.parentPrefaceId;
            this.$emit('filterChanged', returnId, null);
        }
    }

    onChildPrefaceChanged() {
        var returnId1 = this.parentPrefaceId === "" ? null : this.parentPrefaceId;
        var returnId2 = this.childPrefaceId === "" ? null : this.childPrefaceId;
        this.$emit('filterChanged', returnId1, returnId2);
    }

    onClickSearch() {
        var inpElem = this.$refs.refInpSearch as HTMLInputElement;

        var returnId1 = this.parentPrefaceId === "" ? null : this.parentPrefaceId;
        var returnId2 = this.childPrefaceId === "" ? null : this.childPrefaceId;
        this.$emit('searchClickCallback', this.mSearchField, inpElem.value, returnId1, returnId2);
    }      

    getPrefaceText(preface: board.BoardPreface) {
        return getLangProperty(preface, 'prefaceText');
    }
}